module.exports = __webpack_public_path__ + "static/media/analysis2.06e211a6.png";